import React from "react"
import { PopUpCSEXPENSE } from './../../PopUp/PopUpItem'
import PopupApcode from './../../PopUp/PopUpApcode'
import PopUpOther from './../../PopUp/PopUpOther'
import PopUpSaveMoneyExp from './../../PopUp/PopUpSaveMoneyExp'
// import PopUpOther2 from "./../../PSARDeposit/PopUpOrher";
import PopUpOther2 from './../../PopUp/PopUpOther'
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST, genURLTEST } from './../../_getjson';
import { Row, Col, Panel } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { parseJwt } from '../../parseJWT'
import { ReDate } from './../../_source/Datefn'
import Checkdocgroup from './../../CustomFunction/Docgroup/Checkdocgroup'
import Chackdocno from './../../CustomFunction/Docno/GetDocno'
import ChackAp from './../../CustomFunction/Csap/GetAp'
import CheckUser from './../../CustomFunction/Csuser/GetUser'
import CheckBrabchdata from './../../CustomFunction/Branch/Checkdata'
import CheckDepartmentname from './../../CustomFunction/Department/Checkname'
import axios from 'axios'
import Backdrop from './../../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import cheackdate from './../../CustomFunction/Date/Checkdate'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import CheckTaxrate from './../../CustomFunction/Docgroup/CheckTaxrate'
import FullScreenDialogs from '../../PopUp/FullScreendialogs/FullScreen'
import Inputtax from '../../PopUp/FullScreendialogs/Components/Inputtax';
import SelectDatas from "../../PopUp/SelectData"
import MaterialUIPickers from "../../Components/CustomDatepicker/MaterialUIPickers"
import Topbar from "../../Components/Customtopbar/Topbar"
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Hidden } from '@mui/material';
import Moment from 'moment';
import Withholding from '../../PopUp/FullScreendialogs/Components/Withholding'
import UseAutocomplete from "../../Components/CustomInput/UseAutocompletes"
import FullScreenDialognew from "../../Components/CustomDialogs/Fullscreendialog";
import Repostview from "../../Components/Reportview/Repostview";
import Rechecked from "./Components/Rechecked";
import CheckCodeDocGroup from "../../CustomFunction/Docgroup/CheckCodeDocGroup"
import CheckBranchName from './../../CustomFunction/Branch/Checkdata'

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: "0px",
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const RowtableData = 300; //แถวตาราง
//const reporturl = 'flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FOTHERINCOMESLIP&standAlone=true'

export default class index extends React.Component {
    constructor(props) {
        super(props);
        this.SaleDate = React.createRef();
        this.Groupdata_code = React.createRef();
        this.Groupdata = React.createRef();
        this.DeliNumber = React.createRef();
        this.CustomerCode = React.createRef("");
        this.CustomerName = React.createRef("");
        this.Department_code = React.createRef();
        this.Department = React.createRef();
        this.Csuser_code = React.createRef();
        this.Csuser = React.createRef();
        this.Remark = React.createRef();
        this.Branch_code = React.createRef();
        this.Branch = React.createRef();
        this.Wtaxamount = React.createRef();
        this.SumPrice = React.createRef();
        this.TaxPersen = React.createRef();
        this.TaxPrice = React.createRef();
        this.valueTax = React.createRef();
        this.ValueExcept = React.createRef();
        this.TotalPrice = React.createRef("");
        this.Arcode2 = React.createRef();
        this.SaleDocno = React.createRef();
        this.Carnumber = React.createRef();
        this.Kilometer = React.createRef();
        this.Kilometer_2 = React.createRef();
        this.Kilometer_3 = React.createRef();
        this.Docdate_Pay = React.createRef();
        this.Name_Pay = React.createRef();
        this.Account_Pay = React.createRef();
        this.Telephone_AR = React.createRef();
        this.state = {
            TBLastClick: -1,
            // Show_SERIALNUMBER: false,
            products: [],
            openBackdrop: false,
            actionTbtn: "N",
            readData: true,
            urlsend: "",
            Groupdata_txt: "",
            Department_txt: "",
            Branch_txt: "",
            C_TDepartment: "",
            T_Department: "",
            C_TSitecode: "",
            T_Sitecode: "",
            autoClose: 3600,
            color: "warning",
            siteCodeUser1: "",
            messagealert: "",
            inputtax: "",
            selectpopup: "",
            tableother: "",
            Deliverydate: "",
            Docgroupcode: "",
            Notax: "",
            Payablecode: "",
            Payablename: "",
            taxtypecode: "",
            taxtype: "",
            Incometypecode: "",
            Incometype: "",
            Remark: "",
            Deductionconditions: "",
            Taxrate: "",
            Amountbeforetax: "",
            Withholdingtax: "",
            Actingonbehalf: "",
            Totaltax: "",
            defulttable: "",
            openFullScreenDialog: false,
            PriceTypedefaultselect: "0",
            Docdate_Pay: "",
            checkenableInput: [],
            PROJECT: "",
            reporturl: "",
            formPrintdata: "",
            resrecheckeddata: []
        }
    }
    async componentDidMount() {
        //เช็คเปิดปิด textbox 
        await this.setState({
            checkenableInput: JSON.parse(localStorage.getItem('checkoftxt'))
        })
        //await console.log("checkenableInput checkoftxt", this.state.checkenableInput.DocDate)

        let SITECODESTR = parseJwt(localStorage.getItem('Token'))
        this.setState({ siteCodeUser: SITECODESTR.User.SITECODE })
        this.setState({ siteCodeUser1: SITECODESTR.User.CODE })
        this.onAddValue("Csuser", SITECODESTR.User.CODE);
        this.onAddValue("Branch", SITECODESTR.User.SITECODE);
        this.setRow(RowtableData)
        this.setTxt()
        this.setState({ PriceTypedefaultselect: "0" })
        this.setState({ PriceType_code: "0" })

        this.loadCarnumber()

        let mid = new URLSearchParams(location.search).get("mid")
        this.loadFromindb(mid)

    }

    loadFromindb = async (mid) => { //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ 
        let url = `reportmanage/reportform/${mid}?`
        let res = await axios.get(genURL(url))
        //console.log("ressssss", res.data)
        if (res.data.length > 0) {
            await this.setState({ reporturl: res.data[0].pathname })
            await this.setState({ formPrintdata: res.data })
        }
    }

    setRow = (count) => {
        var data = []
        for (var i = 0; i <= count - 1; i++) {
            data[i] = { C0: i + 1, }
        }
        this.setState({ products: data })
    }
    setTxt = () => {
        this.TaxPersen.current.value = parseFloat(7).toFixed(2)
        this.Kilometer.current.value = parseFloat(0).toFixed(2)
        this.Kilometer_2.current.value = parseFloat(0).toFixed(2)
        this.Kilometer_3.current.value = parseFloat(0).toFixed(2)
        this.state.Docdate_Pay = ""
        this.Wtaxamount.current.value = parseFloat(0).toFixed(2)
    }
    escapeRegExp(str) {
        if (str) {
            return str.replace(/,/g, " ")
        } else {
            return ""
        }
    }
    _saveConnection = (e) => {


        this.setState({ PopUpSaveMoney: !this.state.PopUpSaveMoney })

        let chkmuney = (Number(this.state.CashReceipt) +
            Number(this.state.ADVANCEPAYBAL) +
            Number(this.state.PETTYCASH) +
            Number(this.state.BANKAMOUNT) +
            Number(this.state.Incomesum) +
            Number(this.state.cchqssum)) -
            (Number(this.state.BANKEXPEND) +
                Number(this.state.Expensessum))

        //console.log("chkmuney", this.state.Expensessum);

        if (chkmuney === Number(this.TotalPrice.current.value)) {
            this.saveData()
        } else {
            this.openDialog("Payrecord")
        }

    }
    _get_PopUpSaveMoney = async (cash, cchqsarr, csrexpensesarr, csrecincomarr) => {

        let cchqssum = 0
        let Expensessum = 0
        let Incomesum = 0
        cchqsarr.forEach(element => {
            cchqssum += Number(element.Chqamount)
        });
        csrexpensesarr.forEach(element => {
            Expensessum += Number(element.Expensesamount)
        });
        csrecincomarr.forEach(element => {
            Incomesum += Number(element.IncomeAmount)
        });


        // console.log(cash)

        await this.setState({
            CashReceipt: cash[0].Cashbalance,//เงินสด
            BOOKNO: cash[0].Bookno, //เลขบัญชี
            BANKAMOUNT: cash[0].Bankamount, //ยอดเงินโอน
            BANKEXPEND: cash[0].Bankexpend, //ค่าธรรมเนียมจ่ายหักบัญชี
            BOOKDESC: cash[0].Transferremark,
            Expenses: csrexpensesarr,
            Expensessum: Expensessum,
            ADVANCEPAYBAL: cash[0].Advanceamount,
            PETTYCASHCODE: cash[0].Pettycashcode,
            PETTYCASH: cash[0].Pettycashvalue,
            cchqssum: cchqssum,
            cchqs: cchqsarr,
            Income: csrecincomarr,
            Incomesum: Incomesum
        })

        await this._saveConnection()

        //  } else {
        //this.setState({ PopUpSaveMoney: true })
        //  }
    }
    _AddDataSite = (RowId) => {
        setTimeout(() => {
            let arrData = this.state.products
            try {
                arrData[RowId].T_Branch_Code = this.state.C_TSitecode
                arrData[RowId].T_Branch = this.state.T_Sitecode
            } catch (error) {
                console.log("err Adddata>settable sitecode " + error);
            }
            this.setState({ products: arrData })
        }, 100)
    }

    saveData = async () => {

        let Chkinputtaxtable
        if (this.state.inputtax.length > 0) {
            for (let it = 0; it < this.state.inputtax.length; it++) {
                if (this.state.inputtax[it].Taxinvoice != "") {
                    Chkinputtaxtable = this.state.inputtax[it].Taxinvoice
                }
            }
        }
        if (this.TotalPrice.current.value === "0.00") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "จำนวนเงินต้องไม่เท่ากับ 0.00" })
            return
        }
        if (this.Groupdata_code.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })
            this.Groupdata.current.focus()
            return
        } else if (this.CustomerCode.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกรหัสเจ้าหนี้" })
            this.CustomerCode.current.focus()
            return
        } else if (this.Department_code.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกแผนก" })
            this.Department_code.current.focus()
            return
        } else if (this.Branch_code.current.value === "" || this.Branch_code.current.value === "undefined") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกสาขา" })
            this.Branch_code.current.focus()
            return
        } else if /* ( */(this.SumPrice.current.value === "" /* || this.SumPrice.current.value === "0.00")  */ && this.state.PriceType_code !== "2") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาตรวจสอบการกรอกข้อมูล" })
            this.SumPrice.current.focus()
            return
        }


        let table = this.state.products
        for (let i = 0; i < table.length; i++) {

            if (table[i].BTN_T === "1" && typeof Chkinputtaxtable === "undefined") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ให้กำหนดรายการภาษีมูลค่าเพิ่มก่อน" })
                // this.TaxPersen.current.focus()
                return
            }
            if (table[i].BTN_W === "1" && this.state.tableother === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ให้กำหนดรายการภาษีหัก ณ ที่จ่ายก่อน" })
                // this.TaxPersen.current.focus()
                return
            }

            if (table[i].T_Code === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ให้กำหนดข้อมูลในตารางสินค้าก่อน" })
                return
            }
            if (table[i].T_Department_Code === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ให้กำหนดแผนกก่อน" })
                return
            }
            if (table[i].T_Branch_Code === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ให้กำหนดสาขาก่อน" })
                return
            }
            if (table[i].BTN_T === "1" && this.TaxPrice.current.value === "0.00" && (this.state.PriceType_code === "0" || this.state.PriceType_code === "1")) {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ให้กำหนดภาษีมูลค่าเพิ่มก่อน" })
                return
            }
        }

        // console.log("save data ")
        // return
        // console.log(CASHAMOUNT, ADVANCEPAYBAL, PETTYCASHCODE, PETTYCASH, SUMCASH, BOOKNO, BANKAMOUNT, BANKEXPEND, REMARK, sumbank, data3, data4);
        const parameter = new URLSearchParams()
        var dataTT = ""
        var s = [];
        let items = []
        let itemsarr = []
        for (var i = 0; i < this.state.products.length; i++) {
            if (typeof this.state.products[i].T_Code !== "undefined") {
                items[i] = {
                    T_Code: this.state.products[i].T_Code,
                    T_List: this.state.products[i].T_List,
                    T_Explain: (typeof this.state.products[i].T_Explain !== "undefined" ? this.state.products[i].T_Explain : ""),
                    T_Amount: parseFloat(this.state.products[i].T_Amount).toFixed(2),
                    T_Department_Code: this.state.products[i].T_Department_Code,
                    T_Branch_Code: this.state.products[i].T_Branch_Code,
                    BTN_T: this.state.products[i].BTN_T,
                    BTN_W: this.state.products[i].BTN_W,
                    T_Wtaxamount: this.state.products[i].T_Wtaxrate === "" ? "0" : this.state.products[i].T_Wtaxamount,
                    T_Wtaxrate: (this.state.products[i].T_Wtaxrate === "" ? "0" : this.state.products[i].T_Wtaxrate),
                    projectcode: this.state.PROJECT
                }
                itemsarr.push(items[i])
            }

        }
        //------------------------------------------------มาต่อ ---------------------------------------------------

        //console.log(JSON.stringify(this.state.cchqs))

        parameter.append("CSPAYCHQ", JSON.stringify(this.state.cchqs))
        parameter.append("CHEQUEAMOUNT", typeof this.state.Cchqssum === "undefined" ? '0' : this.state.Cchqssum)
        parameter.append("CSRECINCOME", JSON.stringify(this.state.Income))
        parameter.append("INCOMEAMOUNT", this.state.Incomesum)
        parameter.append("CSRECEXPENSE", JSON.stringify(this.state.Expenses))
        parameter.append("EXPENDAMOUNT", this.state.Expensessum)
        parameter.append("listitem", JSON.stringify(itemsarr))
        // เตรียม inputtax เพื่อส่งไปบันทึก   
        var NewCol = []
        var NewCols = []
        var BEFORETAX = 0
        var TAXAMOUNT = 0
        for (let i = 0; i < this.state.tableother.length; i++) {
            if (this.state.tableother[i].Taxinvoice) {
                BEFORETAX += Number(this.state.tableother[i].Amountbeforetax)
                TAXAMOUNT += Number(this.state.tableother[i].Tax)
                NewCol[i] = {
                    Actingonbehalf: this.state.tableother[i].Actingonbehalf,
                    Amountbeforetax: this.state.tableother[i].Amountbeforetax.toString(),
                    Datetime: this.state.tableother[i].Datetime,
                    Deduction: this.state.tableother[i].Deduction,
                    Incometypecode: this.state.tableother[i].Incometypecode,
                    PayableCode: this.state.tableother[i].PayableCode,
                    PayableName: this.state.tableother[i].PayableName,
                    Remark: this.state.tableother[i].Remark,
                    Tax: this.state.tableother[i].Tax,
                    Taxinvoice: this.state.tableother[i].Taxinvoice,
                    Taxrate: this.state.tableother[i].Taxrate,
                    Taxtype: this.state.tableother[i].Taxtype,
                    Taxtypetxt: this.state.tableother[i].Taxtypetxt,
                }

                NewCols.push(NewCol[i]);
            }
        }
        parameter.append("CSAPWTAX", JSON.stringify(NewCols));
        parameter.append("BEFORETAX", BEFORETAX);
        // parameter.append("TAXAMOUNT", TAXAMOUNT);
        parameter.append("TAXAMOUNT2", TAXAMOUNT);

        let datainputtax
        await this.Chkinputtax().then((result) => {
            datainputtax = result
        })
        // console.log("inputtax", this.state.inputtax);
        // console.log("datainputtax", datainputtax);
        // return
        parameter.append("muntitaxinput", JSON.stringify(datainputtax))
        parameter.append("Refundablerate", this.state.Refundablerate)
        parameter.append("Refundablevalue", this.state.Refundablevalue)
        parameter.append("Taxrefund", this.state.Taxrefund)
        parameter.append("Totaltax", this.state.Totaltax)
        // --------------------end muntitaxinput ---------------------------------------- 
        parameter.append("CALCTAX", "")
        // variable : varchar
        parameter.append("CREATEUSER", localStorage.getItem('Username'))
        parameter.append("UPDATEUSER", localStorage.getItem('Username'))
        parameter.append("DOCNO", this.DeliNumber.current.value)
        parameter.append("APCODE", this.CustomerCode.current.value)
        parameter.append("APNAME", this.CustomerName.current.value)
        parameter.append("REMARK", this.Remark.current.value)
        parameter.append("DOCGROUP", this.Groupdata_code.current.value)
        parameter.append("USERCODE", localStorage.getItem('Username'))
        parameter.append("DEPARTMENT", this.Department_code.current.value)
        parameter.append("PROJECT", this.state.PROJECT)
        parameter.append("ALLOCATECODE", "")
        parameter.append("SITECODE", this.Branch_code.current.value)
        parameter.append("REFDOCNO1", "")
        parameter.append("REFDOCNO2", "")
        parameter.append("DISCWORD2", "")
        parameter.append("BOOKNO", this.state.BOOKNO)
        parameter.append("BOOKDESC", this.state.BOOKDESC)
        parameter.append("PETTYCASHCODE", this.state.PETTYCASHCODE)//MT1001
        parameter.append("SYSDOCREMARK", "")
        parameter.append("CLOSEREASON", "")
        parameter.append("OWNERCODE", localStorage.getItem('Username'))
        parameter.append("CURRENCYCODE", "")
        parameter.append("Arcode2", this.Arcode2.current.value)
        parameter.append("SaleDocno", this.SaleDocno.current.value)
        parameter.append("Carnumber", typeof this.state.codeCarnumber !== "undefined" ? this.state.codeCarnumber : "")
        parameter.append("Name_Pay", this.Name_Pay.current.value)
        parameter.append("Account_Pay", this.Account_Pay.current.value)
        parameter.append("Telephone_AR", this.Telephone_AR.current.value)
        // variable : smallint
        parameter.append("CLOSEFLAG", "0")
        parameter.append("COMMFLAG2", "0")
        parameter.append("MANUALPOST", "0")
        parameter.append("TAXTYPE", this.state.PriceType_code)
        parameter.append("TAXAMOUNTFLAG", "0")
        parameter.append("MEDIACLEARING", "0")
        parameter.append("SYSDOCFLAG", "0")
        // variable : decimal(15, 2)
        parameter.append("SUMAMOUNT1", this.SumPrice.current.value)
        parameter.append("SUMAMOUNT2", this.ValueExcept.current.value)
        parameter.append("SUMAMOUNT2B", "0")
        parameter.append("BANKAMOUNT", this.state.BANKAMOUNT)
        parameter.append("BANKEXPEND", this.state.BANKEXPEND)
        parameter.append("PETTYCASH", this.state.PETTYCASH)
        parameter.append("ADVANCEPAYBAL", this.state.ADVANCEPAYBAL)
        parameter.append("ADVANCEPAY", this.state.ADVANCEPAYBAL)
        parameter.append("CASHAMOUNT", this.state.CashReceipt)

        parameter.append("DEPOSITAMOUNT", "0")
        parameter.append("INCOMEAMOUNT", "0")
        parameter.append("EXPENDAMOUNT", "0")
        parameter.append("B_AMOUNT", "0")
        parameter.append("B_TAXRATE", "0")
        parameter.append("B_TAXAMOUNT", " 0")
        parameter.append("EXCHANGERATE", "0")
        parameter.append("BATHDEBTAMOUNT", "0")
        parameter.append("BATHSUMAMOUNT1", "0")
        parameter.append("BATHSUMAMOUNT2", "0")
        parameter.append("BATHDISCAMOUNT1", "0")
        parameter.append("BATHDISCAMOUNT2", "0")
        parameter.append("BATHTAXAMOUNT", "0")
        parameter.append("BATHTOTALAMOUNT", "0")
        parameter.append("STARTCREATE", "0")
        parameter.append("FINISHCREATE", "0")
        parameter.append("Kilometer", this.Kilometer.current.value)
        parameter.append("Kilometer_2", this.Kilometer_2.current.value)
        parameter.append("Kilometer_3", this.Kilometer_3.current.value)
        parameter.append("Docdate_Pay", this.state.Docdate_Pay)
        //datetime
        parameter.append("SYSCREATE", "")
        parameter.append("SYSUPDATE", "")
        parameter.append("DOCDATE", this.state.documentDate)
        parameter.append("DISCAMOUNT2", "0")
        parameter.append("TAXRATE", Number(this.TaxPersen.current.value))
        parameter.append("TAXAMOUNT", Number(this.TaxPrice.current.value))
        parameter.append("TOTALAMOUNT", this.valueTax.current.value)
        parameter.append("DEBTAMOUNT", this.TotalPrice.current.value)
        parameter.append("WTAXAMOUNT", Number(this.Wtaxamount.current.value))

        var Uststus = true
        for (var pair of parameter.entries()) {
            //console.log(pair[0], "==", pair[1]);
            if (pair[1] === "" && pair[0] === "APCODE") {
                Uststus = false
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกรหัสเจ้าหนี้" })
            } else if (pair[1] === "" && pair[0] === "DOCGROUP") {
                Uststus = false
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })

            } else if (pair[1] === "" && pair[0] === "DEPARTMENT") {
                Uststus = false
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกแผนก" })
            } else if (pair[1] === "" && pair[0] === "SITECODE") {
                Uststus = false
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกสาขา" })
            }
        }

        if (Uststus === true) {

            // return
            this.setState({ openBackdrop: true })
            // var url = "CSOTHEREXPENSE/Save?l=0"
            //  test
            // await axios.post(genURLTEST("Save?l=0"), parameter).then(res => {
            // actually use
            await axios.post(genURL("CSOTHEREXPENSE/Save?l=0"), parameter).then(res => {
                console.log("respost", res)
                if (res.data.status === "success") {
                    this.setState({ openBackdrop: false })
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "success" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกสำเร็จ" })
                    setTimeout(() => {
                        // this._refreshPage();
                        // this.setState({ openBackdrop: false })
                        // this.ResetThisPage()
                        this._printReport(res.data.docno)
                    }, 30);
                } else {
                    this.setState({ openBackdrop: false })
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกข้อมูลไม่สำเร็จ" + res.data.status })
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                this.setState({ openBackdrop: false })
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
                this.setState({ openBackdrop: false })
            });
        }
    }
    Chkinputtax = async () => {
        let Chkinputtax = []
        var sinputtax = []
        if (this.state.inputtax.length > 0) {
            for (var i = 0; i < this.state.inputtax.length && this.state.inputtax[i].Taxinvoice; i++) {
                sinputtax[i] = {
                    Taxinvoice: this.state.inputtax[i].Taxinvoice,
                    Invoicedate: (Moment(this.state.inputtax[i].Invoicedate, 'DD/MM/YYYY').add(-543, 'year').format('YYYY-MM-DD')),
                    PayableCode: this.state.inputtax[i].PayableCode,
                    PayableName: this.state.inputtax[i].PayableName,
                    Taxdescription: this.state.inputtax[i].Taxdescription,
                    Amountbeforetax: this.state.inputtax[i].Amountbeforetax.toString(),
                    Tax: this.state.inputtax[i].Tax,
                    Taxincluded: this.state.inputtax[i].Taxincluded,
                    Refundablerate: this.state.inputtax[i].Refundablerate,
                    Refundablevalue: this.state.inputtax[i].Refundablevalue,
                    Refundabletax: this.state.inputtax[i].Refundabletax
                }
                Chkinputtax.push(sinputtax[i]);
            }
        }
        return await Chkinputtax
    }
    ResetThisPage = () => {
        window.location.replace("/PSExpenses");
    }
    /*----------------------------------------------------------------------------------------------------------------------------*/
    SelectSetData = async (data1, data2, rowIndex) => {
        switch (data1) {
            case "Calendar1": this.DeliDate.current.value = data2
                break;
            case "PriceType":
                if (data2 !== "") {
                    await this.setState({ PriceType_code: data2 })
                    //      console.log("PriceType", data2);
                    await this.setState({ PriceTypedefaultselect: String(data2) })
                }
                this.Cal_Price()
                break;
            case "PROJECT":
                //textproject
                if (rowIndex === "") {
                    this.setState({ PROJECT: data2 })
                    //settableproject
                    for (let i = 0; i < this.state.products.length; i++) {
                        if (this.state.products[i].T_Code) {
                            this.state.products[i].PROJECT = data2
                            this.state.products[i].projectcode = data2
                        }
                    }
                }
                // tableproject
                if (rowIndex !== "") {
                    this.state.products[Number(rowIndex)].PROJECT = data2
                    this.state.products[Number(rowIndex)].projectcode = data2
                }
                break;
            default:
                break;
        }


    }
    Get_PopupApcode = (data1, data2, data3, TAXTYPE) => {
        this.CustomerCode.current.value = data1
        this.CustomerName.current.value = data2
        //  console.log("TAXTYPE", TAXTYPE)
        this.SelectSetData("PriceType", String(TAXTYPE));
    }
    Get_PopUpOther = async (val) => {
        var data = val.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        switch (this.state.OtPopupType) {
            case "Groupdata":
                this.Groupdata_code.current.value = data[0]
                this.Groupdata.current.value = data[1]
                this.setState({ Groupdata_txt: data[1] });
                await Chackdocno(data[0], "CSOTHEREXPENSE").then(async (result1) => {
                    //  console.log(result1);
                    if (result1 !== undefined) {
                        this.DeliNumber.current.value = await result1
                    } else {
                        this.DeliNumber.current.value = ""
                    }
                }).finally(_ => {
                    CheckTaxrate(data[0], "CSOTHEREXPENSE").then((result) => {
                        //   console.log("sssss", result);
                        this.TaxPersen.current.value = result
                    })
                }).catch((err) => {
                    this.DeliNumber.current.value = ""
                    console.log(err);
                });
                break;
            case "Department":
                this.Department_code.current.value = await data[0];
                this.Department.current.value = await data[1];
                this.setState({ Department_txt: data[1] });
                break;
            case "Branch":
                this.Branch_code.current.value = await data[0];
                this.Branch.current.value = await data[1];
                this.setState({ Branch_txt: data[1] });
                break;
            default:
                break;
        }
    };

    _cellButton(cell, row, enumObject, rowIndex) {
        var btn = row.BTN_Code
        var btnShow = ""
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => this.Switch_PopUpCSEXPENSE("Search_Expense")} onMouseDown={(e) => { this.setState({ TBLastClick: row.C0 }) }}>
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>

                break;
            case 2:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
                    <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
                </div>
                break;
            default: btnShow = <i id={"Icon_row" + row.C0} style={{ fontSize: "10px", color: "#000" }} ></i>
                break;
        }
        return (<div>{btnShow}</div>)
    }
    _cellButton2(cell, row, enumObject, rowIndex) {
        var btn = row.BTN_Department;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={this.SetPopup.bind(null, "Department")} >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <i className=""></i>;
                break;
        }
        return (<div>{btnShow}</div>);
    }
    _cellButton3(cell, row, enumObject, rowIndex) {
        var btn = row.BTN_ฺฺBranch;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={this.SetPopup.bind(null, "Branch")} >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
                    <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
                </div>;
                break;
            default: btnShow = <i id={"Icon_row" + row.C0} style={{ fontSize: "10px", color: "#000" }} ></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    Button_T(cell, row, enumObject, rowIndex) {
        if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            var btn = this.state.products[rowIndex].BTN_T;
            var btnShowT;
            switch (btn) {
                case "0":
                    btnShowT = (
                        <span>
                            <i className="far fa-square "
                                onClick={this.t_Status.bind(null, rowIndex, "1")} style={{ paddingTop: "7px" }}></i>
                        </span>
                    );
                    break;
                case "1":
                    btnShowT = (
                        <span>
                            <i className="far fa-check-square" onClick={this.t_Status.bind(null, rowIndex, "0")} style={{ paddingTop: "7px" }}></i>
                        </span>
                    );
                    break;
                default: btnShowT = (<span><i className=""></i></span>);
            }
            return <div>{btnShowT}</div>;
        }
    }
    t_Status = async (Row, Status) => {
        var dataArray = this.state.products;
        dataArray[Row].BTN_T = Status;
        await this.setState({ products: dataArray });
        setTimeout(() => {
            this.Cal_Price()
        }, 100);
    }
    Button_W(cell, row, enumObject, rowIndex) {
        var btnShow = ""
        switch (row.BTN_W) {
            case "0": btnShow = <div onClick={this.W_Status.bind(null, rowIndex, "1")}><i className="far fa-square" style={{ paddingTop: "7px" }}></i></div>
                break;
            case "1": btnShow = <div onClick={this.W_Status.bind(null, rowIndex, "0")}><i className="far fa-check-square" style={{ paddingTop: "7px" }}></i></div>
                break;
            default: btnShow = ""
                break;
        }
        return (<div>{btnShow}</div>)
    }

    W_Status = (Row, Status) => {
        //  console.log(Row);
        var dataArray = this.state.products;
        dataArray[Row].BTN_W = Status;

        this.setState({ products: dataArray });
        var table = this.state.products
        // var sum = 0
        // if (Status === "1") {
        //     if (this.state.PriceType_code === "1") {
        //         let sum1 = 100 + Number(this.TaxPersen.current.value)
        //         sum += Number(table[Row].T_Amount / sum1 * table[Row].T_Wtaxrate)
        //     } else if (this.state.PriceType_code !== "1") {
        //         sum += Number(table[Row].T_Amount / 100 * table[Row].T_Wtaxrate)
        //     }
        //     // sum += Number(table[Row].T_Amount / 100 * table[Row].T_Wtaxrate)
        //     table[Row].T_Wtaxamount = parseFloat(sum).toFixed(2)
        // } else if (Status === "0") {
        //     table[Row].T_Wtaxamount = "0.00"
        // }
        setTimeout(() => {
            var sumamount = 0
            for (let i = 0; i < table.length && table[i].T_Code; i++) {
                if (table[i].BTN_W === "1" && this.state.PriceType_code === "1") {
                    let sum1 = 100 + Number(this.TaxPersen.current.value)
                    sumamount += Number(table[i].T_Amount / sum1 * table[i].T_Wtaxrate)
                } else if (table[i].BTN_W === "1" && this.state.PriceType_code !== "1") {
                    sumamount += Number(table[i].T_Amount / 100 * table[i].T_Wtaxrate)
                }
            }
            this.Wtaxamount.current.value = parseFloat(sumamount).toFixed(2)
        }, 200);
    }

    rowClassNameFormat = (row, rowIdx) => {
        return 'trClassName'
    }
    onRowClick = (row, col, id) => {
        // ไม่ให้คีย์ข้ามแถ
        this.setState({ col1: false });
        this.setState({ col: false });
        let T_Amount = row.T_Amount // จำนวนเต็มเวลาคลิก
        if (col === 5 && T_Amount !== "" && T_Amount !== undefined) {
            row.T_Amount = parseFloat(T_Amount).toFixed(0)
        }

        // this.setState({ cellValue: row.T_Code })
        var Pr = this.state.products
        this.setState({ WHRow1: id });
        this.setState({ TBLastClick: Pr[id] })
        var j = RowtableData
        for (var i = 0; i < Pr.length; i++) {
            Pr[i].BTN_Code = 0;
            Pr[i].BTN_Department = 0;
            Pr[i].BTN_ฺฺBranch = 0;
        }
        for (var i = this.state.products.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
            if (!this.state.products[i].T_Code) {
                j = i
            }
        }//หา แถวที่ว่างบนสุดใน products Table 
        if ((col === 1 && j === id) || (col === 1 && Pr[id].T_Code !== undefined)) {
            this.setState({ col1: true })
            Pr[id].BTN_Code = 1
        } else if (col === 6 && typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            Pr[id].T_Department = Pr[id].T_Department_Code;
            this.setState({ tableData: Pr });
            Pr[id].BTN_Department = 1;
        } else if (col === 9 && typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            Pr[id].T_Branch = Pr[id].T_Branch_Code;
            this.setState({ tableData: Pr });
            Pr[id].BTN_ฺฺBranch = 1;
        }
        // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
        if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
            this.setState({ col: true });
            // BTN วันที่
        }
        this.setState({ products: Pr })
        /* if (col === 3 && row.T_Code !== null && (row.T_Code)[0] + "" + (row.T_Code)[1] === "11") {
            this.setState({
                se_Row: row.C0,
                se_PRODUCTCODE: row.T_Code,
                se_WAREHOUSE: row.T_Explain,
                se_LOCATION: row.T_Amount,
            })
        } */
    }
    onAfterSaveCell = (row, cellName, cellValue) => {
        var i = row.C0 - 1
        // ทศนิยม 2 ตำแหน่ง จำนวนเงิน
        let T_Amount = row.T_Amount
        // let T_Wtaxrate = row.T_Wtaxrate
        if (cellName === "T_Amount" && T_Amount !== "") {
            row.T_Amount = parseFloat(T_Amount).toFixed(2)
            this.Cal_Price()
            //   console.log("onAfterSaveCell", cellName);
            //  console.log(i, row.BTN_W);
            if (row.BTN_W === "1") {
                this.W_Status(i, "1")
            }
        }
        //end 
        // var cellValue1 = this.state.cellValue
        if (cellName === 'T_Code' && cellValue !== "" /* && cellValue1 !== cellValue */) {
            var col = this.state.products
            col[i] = []
            col[i].C0 = row.C0
            col[i].BTN_Code = row.BTN_Code
            this.setState({ products: col })
            this.AddDataTable(cellValue, i)
        } else if (cellName === 'T_Code' && cellValue === "") {
            setTimeout(() => {
                this.ReLoadData()
            }, 500);
        }
        if (cellName === "T_Department" && cellValue === "") {
            row.T_Department_Code = "";
            row.T_Department = "";
        }
        if (cellName === "T_Department" && cellValue !== "" && cellValue !== row.T_Department_Code) {
            CheckDepartmentname(cellValue).then(async (result) => {
                //    console.log("sss", result);
                if (result !== "") {
                    row.T_Department_Code = cellValue
                    row.T_Department_Name = result
                    row.T_Department = await result
                    await this.ReLoadData()
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล" })
                    row.T_Department_Code = "";
                    row.T_Department_Name = "";
                    row.T_Department = "";
                }
            }).catch(error => {
                row.T_Department_Code = "";
                row.T_Department_Name = "";
                row.T_Department = "";
                console.log(error);
            });
        } else if ((cellName === "T_Department" && cellValue !== "" && cellValue === row.T_Department_Code)) {
            row.T_Department = row.T_Department_Name
        }
        if (cellName === "T_Branch" && cellValue === "") {
            row.T_Branch_Code = ""
            row.T_Branch = ""
        }
        if (cellName === "T_Branch" && cellValue !== "" && cellValue !== row.T_Branch_Code) {
            CheckBrabchdata(cellValue).then(async (result) => {
                console.log("result", result[0]);
                if (result !== "") {
                    row.T_Branch_Code = result[1]
                    row.T_Branch_Name = result[0]
                    row.T_Branch = await result[0]
                    await this.ReLoadData()
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล" })
                    row.T_Branch_Code = "";
                    row.T_Branch_Name = "";
                    row.T_Branch = "";
                }
            }).catch(error => {
                row.T_Branch_Code = "";
                row.T_Branch_Name = "";
                row.T_Branch = "";
                console.log(error);
            });
        } else if (cellName === "T_Branch" && cellValue !== "" && cellValue === row.T_Branch_Code) {
            row.T_Branch = row.T_Branch_Name
        }
    }
    Get_PopUpCSEXPENSE = (data) => {
        this.AddDataTable(data.code)
    }
    addByBarCode = (e) => {
        if (e.key === "Enter") {
            this.AddDataTable(e.target.value)
            this.barcode.current.value = ""
        }
    }
    AddDataTable = (ItemCode, row) => {
        var j = 20
        var col = this.state.products
        var url = "CSOTHEREXPENSE/Searchexpense?top=1&Code=" + ItemCode + "&user=" + localStorage.getItem("Username");
        //รหัสซ้ำให้มีอันเดียว//
        // for (var i = 0; i < col.length; i++) {
        //     if (col[i].T_Code === ItemCode) {
        //         return
        //     }
        // }
        //  console.log(genURL(url));
        axios.get(genURL(url), { timeout: 3600 }).then(res => {
            //  console.log("CSOTHEREXPENSEresdata", res.data);
            if (row > -1) {
                j = row
            } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
                j = this.state.TBLastClick - 1
            } else {
                for (var i = this.state.products.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน
                    if (!this.state.products[i].T_Code) { j = i }
                }
            }
            if (res.data && res.data.length > 0) {
                col[j] = {
                    C0: j + 1,
                    T_Code: res.data[0].CODE,
                    BTN_Code: col[0].BTN_Code,
                    T_List: res.data[0].MYNAMETH,
                    BTN_T: String(res.data[0].CALCTAX),
                    BTN_W: String(res.data[0].CALCWTAX),
                    T_Amount: "0.00",
                    T_Department_Code: this.Department_code.current.value,
                    T_Department_Name: this.Department.current.value,
                    T_Department: this.Department.current.value,
                    T_Branch_Code: this.Branch_code.current.value,
                    T_Branch_Name: this.Branch.current.value,
                    T_Branch: this.Branch.current.value,
                    tCode: "0",
                    T_Wtaxamount: "0.00",
                    T_Wtaxrate: res.data[0].WTAXRATE === null ? "" : res.data[0].WTAXRATE,
                    PROJECT: this.state.PROJECT
                }
                this.setState({ products: col })
                this.ReLoadData()
            } else {
                col[j] = {
                    C0: j + 1
                }
                this.setState({ products: col })
                this.ReLoadData()
            }
        })
        // setTimeout(() => {
        //     document.getElementById("TableLoadItem").innerHTML = ""
        // }, 30000)
    }

    ReLoadData = () => { //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
        var col = this.state.products
        var NewCol = []
        var j = 0
        // var Ch = 0
        for (var i = 0; i < col.length; i++) {
            if (col[i].T_Code) {
                // if ((col[i].T_Code)[0] + "" + (col[i].T_Code)[1] === "11") { Ch++ }
                NewCol[j] = col[i]
                NewCol[j].C0 = j + 1
                if (col[i].T_Branch > col[i].MaxUnit) {
                    if (col[i].MaxUnit <= 0) {
                        col[i].T_Branch = 1
                    } else {
                        col[i].T_Branch = col[i].MaxUnit
                        this.setState({ opensnackbar: true })
                        this.setState({ color: "warning" })
                        this.setState({ icon: ErrorIcon })
                        this.setState({ messagealert: col[i].T_Code + "จำกัดสินค้า" + col[i].MaxUnit + " " + col[i].T_Department })
                    }
                }
                NewCol[j].C9 = (col[i].C7 * col[i].T_Branch) - NewCol[j].C8
                j++

                if (this.state.actionTbtn === "Y") {
                }
            }
        }
        // if (Ch > 0) {
        //     this.setState({ Show_SERIALNUMBER: true })
        // } else { this.setState({ Show_SERIALNUMBER: false }) }
        for (var i = j; i < col.length; i++) {
            NewCol[j] = { C0: j + 1 }
            j++
        }
        this.setState({ products: NewCol })
        setTimeout(() => {
            this.Cal_Price()
            this.setState({ PriceType_code: this.state.PriceType_code })
        }, 300)
    }
    /*----------------------------------------------------------------------------------------------------------------------------*/
    Cal_Price = () => {

        //   console.log("PriceType_code Cal_Price", this.state.PriceType_code);
        let ty_code = this.state.PriceType_code
        let TaxPersen = Number(this.TaxPersen.current.value);
        this.TaxPersen.current.value = parseFloat(TaxPersen).toFixed(2)
        let SumPrice = 0.00;
        let TaxPrice = 0.00;
        let ValueExcept = 0.00;
        let TotalPrice = 0.00;
        for (var i = 0; i < this.state.products.length; i++) {


            if (this.state.products[i].T_Amount) {
                var sum = 0
                if (ty_code === 1) {
                    let sum1 = 100 + Number(this.TaxPersen.current.value)
                    sum += Number(this.state.products[i].T_Amount / sum1 * this.state.products[i].T_Wtaxrate)
                } else if (ty_code !== 1) {
                    sum += Number(this.state.products[i].T_Amount / 100 * this.state.products[i].T_Wtaxrate)
                }
                this.state.products[i].T_Wtaxamount = parseFloat(sum).toFixed(2)
                // T คลิกถูก  

                //  console.log("PriceType_code BTN_T", this.state.products[i].BTN_T);
                if (this.state.products[i].BTN_T === "1") {
                    // เลือกประเภทราคา 
                    if (ty_code === "0") {
                        // console.log("PSExpenses ty_code", ty_code);
                        SumPrice += parseFloat(this.state.products[i].T_Amount)
                        TaxPrice = 100
                        TotalPrice = SumPrice + (TaxPersen * SumPrice / TaxPrice)

                        // return
                    } else if (ty_code === "1") {
                        //    console.log("PSExpenses ty_code", ty_code);
                        SumPrice += parseFloat(this.state.products[i].T_Amount)
                        TaxPrice = 100 + TaxPersen
                        TotalPrice += parseFloat(this.state.products[i].T_Amount)
                    } else if (ty_code === "2") {
                        //  console.log("PSExpenses ty_code", ty_code);
                        SumPrice += parseFloat(this.state.products[i].T_Amount)
                        TaxPrice = 0
                        TotalPrice += parseFloat(this.state.products[i].T_Amount)
                    }
                } else {

                    if (ty_code === "0") {
                        TaxPrice = 100
                        ValueExcept += parseFloat(this.state.products[i].T_Amount)
                        TotalPrice += parseFloat(this.state.products[i].T_Amount)
                        // console.log("PriceType_code ValueExcept", ValueExcept);

                    } else if (ty_code === "1") {
                        TaxPrice = 100 + TaxPersen
                        ValueExcept += parseFloat(this.state.products[i].T_Amount)
                        TotalPrice += parseFloat(this.state.products[i].T_Amount)
                        //  console.log("PriceType_code ValueExcept", ty_code, ValueExcept);
                    } else if (ty_code === "2") {
                        TaxPrice = 0
                        ValueExcept += parseFloat(this.state.products[i].T_Amount)
                        TotalPrice += parseFloat(this.state.products[i].T_Amount)
                    }
                }
                this.SumPrice.current.value = SumPrice.toFixed(2)
                if (ty_code === "2") {
                    this.TaxPrice.current.value = "0.00"
                }
                else if (SumPrice !== 0.00) {
                    this.TaxPrice.current.value = parseFloat(TaxPersen * SumPrice / TaxPrice).toFixed(2)
                } else {
                    this.TaxPrice.current.value = "0.00"
                }
                this.valueTax.current.value = SumPrice.toFixed(2)
                this.ValueExcept.current.value = parseFloat(ValueExcept).toFixed(2)
                this.TotalPrice.current.value = TotalPrice.toFixed(2)
                this.setState({ AmountPayable: this.TotalPrice.current.value });
            }
        }
    }
    Cal_Price1 = (e) => {
        if (e.key === "Enter" && e.target.value !== "") {
            this.Cal_Price();
        }
    }
    /*------------------------------------------------------------พิเศษ------------------------------------------------------------*/
    onChangeData = (e) => {
        var name = e.target.name
        if (e.key === "Enter" && e.target.value !== "") {
            this.onAddValue(name, e.target.value)
        }
    }
    onAddValue = async (type, value, Fix) => {
        if (value) {
            switch (type) {
                case "Groupdata":
                    Checkdocgroup(value, "CSOTHEREXPENSE", Fix).then(async (result) => {
                        if (result !== "") {
                            this.Groupdata_code.current.value = value
                            this.Groupdata.current.value = result
                            this.setState({ Groupdata_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Groupdata_code.current.value = ""
                            this.Groupdata.current.value = ""
                            this.setState({ Groupdata_txt: "" });
                            this.DeliNumber.current.value = ""
                        }
                    }).finally(_ => {
                        CheckTaxrate(value, "CSOTHEREXPENSE").then((result) => {
                            console.log("sssss", result);
                            this.TaxPersen.current.value = result
                        })
                    }).catch((err) => {
                        this.Groupdata_code.current.value = ""
                        this.Groupdata.current.value = ""
                        this.setState({ Groupdata_txt: "" });
                        this.DeliNumber.current.value = ""
                        console.log(err);
                    });

                    if (Fix !== "Y") {
                        await Chackdocno(value, "CSOTHEREXPENSE").then((result1) => {
                            if (result1 !== "") {
                                this.DeliNumber.current.value = result1
                            } else {
                                this.DeliNumber.current.value = ""
                            }
                        }).catch((err) => {
                            this.DeliNumber.current.value = ""
                            console.log(err);
                        });
                    } else {
                        this.DeliNumber.current.value = ""
                    }
                    break;
                case "CustomerCode":
                    //   console.log("CustomerCode");
                    await ChackAp(value).then((result) => {
                        // console.log("result", result);
                        if (result !== "") {
                            let data = result.split("|")
                            this.CustomerCode.current.value = value
                            this.CustomerName.current.value = data[0]
                            this.setState({ PriceTypedefaultselect: data[2] })
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.CustomerCode.current.value = ""
                            this.CustomerName.current.value = ""
                        }
                    }).catch((err) => {
                        this.CustomerCode.current.value = ""
                        this.CustomerName.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Csuser":
                    await CheckUser(value).then(async (result) => {
                        if (result !== "") {
                            this.Csuser_code.current.value = await value
                            this.Csuser.current.value = await result
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Csuser_code.current.value = ""
                            this.Csuser.current.value = ""
                        }
                    }).catch((err) => {
                        this.Csuser_code.current.value = ""
                        this.Csuser.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Department":
                    await CheckDepartmentname(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            this.Department_code.current.value = value
                            this.Department.current.value = result
                            this.setState({ Department_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Department_code.current.value = ""
                            this.Department.current.value = ""
                            this.setState({ Department_txt: "" });
                        }
                    }).catch((err) => {
                        this.Department_code.current.value = ""
                        this.Department.current.value = ""
                        this.setState({ Department_txt: "" });
                        console.log(err);
                    });
                    break;
                case "Branch":
                    await CheckBrabchdata(value).then((result) => {
                        if (result !== "") {

                            this.Branch_code.current.value = result[1]
                            this.Branch.current.value = result[0]

                            this.setState({ Branch_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Branch_code.current.value = ""
                            this.Branch.current.value = ""
                            this.setState({ Branch_txt: "" });
                        }
                    }).catch((err) => {
                        //  this.Branch_code.current.value = null
                        // this.Branch.current.value = ""
                        // this.setState({ Branch_txt: "" });
                        console.log(err);
                    });
                    break;
                default: break;
            }
        }
    };
    _reCHK = async (RowData) => {
        this.setState({ openFullScreenDialogs: false })
        this.setState({ readData: true })
        this.setState({ openBackdrop: true })

        console.log("RowData", RowData)

        await axios.get(genURL("CSOTHEREXPENSE/Getbycodemain?code=" + RowData[0].docno), { timeout: 3600 }).then(res => {
            if (res.data) {
                // this.SaleDate.current.value = ReDate(res.data[0].DOCDATE);
                console.log("res", res.data)
                this.setState(
                    {
                        PROJECT: res.data[0].PROJECT,
                        cbcdefaultvalue: res.data[0].Carnumber,
                        resrecheckeddata: res.data,
                        AmountPayable: res.data[0].TOTALAMOUNT
                    }
                )
                this.setState({ documentDate: ReDate(res.data[0].DOCDATE) })
                this.setState({ defaultdocumentDate: !res.data[0].Docdate_Pay === null ? ReDate(res.data[0].Docdate_Pay) : "" })
                this.CustomerCode.current.value = res.data[0].APCODE
                this.CustomerName.current.value = res.data[0].APNAME
                this.Wtaxamount.current.value = res.data[0].WTAXAMOUNT
                // this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
                this.reCheckGetData("Groupdata", res.data[0].DOCGROUP, "Y")
                this.onAddValue("Csuser", res.data[0].USERCODE);
                this.onAddValue("Department", res.data[0].DEPARTMENT);
                this.onAddValue("Branch", res.data[0].SITECODE);
                this.DeliNumber.current.value = res.data[0].DOCNO
                /* this.RefTAXNO.current.value = res.data[0].TAXNO */
                this.Remark.current.value = res.data[0].REMARK;
                // this.SelectSetData("PriceType", String(res.data[0].TAXTYPE));
                console.log("TAXTYPE", res.data[0].TAXTYPE);
                this.setState({ PriceTypedefaultselect: String(res.data[0].TAXTYPE) })
                this.SumPrice.current.value = parseFloat(res.data[0].SUMAMOUNT1).toFixed(2)
                this.TaxPersen.current.value = parseFloat(res.data[0].TAXRATE).toFixed(2)
                this.TaxPrice.current.value = parseFloat(res.data[0].TAXAMOUNT).toFixed(2)
                this.valueTax.current.value = parseFloat(res.data[0].TOTALAMOUNT).toFixed(2)
                this.ValueExcept.current.value = parseFloat(res.data[0].SUMAMOUNT2).toFixed(2)
                this.TotalPrice.current.value = parseFloat(res.data[0].DEBTAMOUNT).toFixed(2)
                this.Arcode2.current.value = res.data[0].Arcode2
                this.SaleDocno.current.value = res.data[0].SaleDocno

                this.Kilometer.current.value = res.data[0].Kilometer
                this.Kilometer_2.current.value = res.data[0].Kilometer_2
                this.Kilometer_3.current.value = res.data[0].Kilometer_3
                this.state.Docdate_Pay = res.data[0].Docdate_Pay == null ? "" : ReDate(res.data[0].Docdate_Pay);
                this.Name_Pay.current.value = res.data[0].Name_Pay
                this.Account_Pay.current.value = res.data[0].Account_Pay
                this.Telephone_AR.current.value = res.data[0].Telephone_AR
                this.setState({ openBackdrop: false })
                this.setState({ PROJECT: res.data[0].PROJECT })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ openBackdrop: false })
        })




        var url1 = "CSOTHEREXPENSE/Getbycodesub?code=" + RowData[0].docno;

        await axios.get(genURL(url1), { timeout: 3600 }).then(async (res) => {

            console.log("res", res);
            if (res.data) {

                var data = this.state.products;
                for (var i = 0; i < res.data.length; i++) {
                    data[i].T_Code = res.data[i].EXPCODE;
                    data[i].T_List = res.data[i].EXPNAME;
                    data[i].T_Explain = res.data[i].REMARK;
                    data[i].T_Amount = res.data[i].AMOUNT;
                    data[i].PROJECT = res.data[i].PROJECT

                    data[i].BTN_T = String(res.data[i].CALCTAX);
                    data[i].BTN_W = String(res.data[i].CALCWTAX);
                    data[i].T_Department_Code = res.data[i].DEPARTMENT;
                    data[i].T_Wtaxamount = res.data[i].WTAXAMOUNT;
                    data[i].T_Wtaxrate = res.data[i].WTAXRATE;
                    await CheckDepartmentname(res.data[i].DEPARTMENT).then(async (result) => {
                        if (result !== "") {
                            data[i].T_Department = await result
                            data[i].T_Department_Name = await result
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            data[i].T_Department_Code = ""
                            data[i].T_Department_Name = ""
                            data[i].T_Department = ""
                        }
                    }).catch((err) => {
                        data[i].T_Department_Code = ""
                        data[i].T_Department_Name = ""
                        data[i].T_Department = ""
                        console.log(err);
                    });
                    data[i].T_Branch_Code = res.data[i].SITECODE;
                    await CheckBranchName(res.data[i].SITECODE).then(async (result) => {
                        if (result !== "") {
                            data[i].T_Branch = await result// await result
                            data[i].T_Branch_Name = await result

                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            data[i].T_Branch_Code = ""
                            data[i].T_Branch_Name = ""
                            data[i].T_Branch = ""
                        }
                    }).catch((err) => {
                        data[i].T_Branch_Code = ""
                        data[i].T_Branch_Name = ""
                        data[i].T_Branch = ""
                        console.log(err);
                    });
                    await this.setState({ products: data })
                    // setTimeout(() => {
                    //     this.ReLoadData();
                    // }, 500);
                }
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ openBackdrop: false })
        }).finally(_ => {
            //   this.SELECTPROJECT()
        });
    }
    /*----------------------------------------------------------Switch------------------------------------------------------------------*/
    Switch_PopUpCSEXPENSE = (e) => {
        // this.setState({ SwitchPopUpCSEXPENSE: !this.state.SwitchPopUpCSEXPENSE })
        //ชื่อ
        this.setState({ typeFullScreenDialogs: e })
        //open
        this.setState({ openFullScreenDialogs: true })
        //title
        this.setState({ titleFullScreenDialogs: "ค้นหารหัสค่าใช้จ่ายอื่นๆ-Expense" })
    }
    SetPopup = (data) => {
        this.setState({ PopUpTYpe: data });
        this.setState({ showPopupOT: !this.state.showPopupOT });
    };
    PopUpOtherClose = () => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    };
    Switch_PopupApcode = (e) => {
        this.setState({ SwitchPopupApcode: !this.state.SwitchPopupApcode })
    }
    Switch_OtherPopup = (type) => {
        this.setState({ OtPopupType: type })
        this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup })
    }
    Switch_Report = (e) => {
        this.setState({ SwitchReport: !this.state.SwitchReport })
    }

    Switch_PopUpSaveMoney = (e) => {
        this.setState({ PopUpSaveMoney: !this.state.PopUpSaveMoney })
    }
    Get_PopUpOther2 = data => {
        var DataValue = data.split("|");
        var Pr = this.state.products;
        var r = this.state.WHRow1;
        console.log(this.state.PopUpTYpe, DataValue);
        switch (this.state.PopUpTYpe) {
            case "Department":
                this.setState({ C_TDepartment: DataValue[0] });
                this.setState({ T_Department: DataValue[1] });
                Pr[r].TypeBtn2 = 1;
                Pr[r].T_Department_Code = DataValue[0]
                Pr[r].T_Department_Name = DataValue[1]
                Pr[r].T_Department = DataValue[1]
                Pr[r].TypeBtn2 = 2;
                this.setState({ products: Pr });
                break;
            case "Branch":
                this.setState({ C_TSitecode: DataValue[0] });
                this.setState({ T_Sitecode: DataValue[1] });
                Pr[r].TypeBtn3 = 1;
                Pr[r].T_Branch_Code = DataValue[0]
                Pr[r].T_Branch_Name = DataValue[1];
                Pr[r].T_Branch = DataValue[1];
                Pr[r].TypeBtn3 = 2;
                this.setState({ products: Pr });
                break;
        }
    };
    _print = () => {
        console.log(this.DeliNumber.current.value);
        if (this.DeliNumber.current.value !== "") {
            let url = "https://csrpt.pspl.co.th/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FCSOTHEREXPENSE&standAlone=true&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf&docno=";
            this.setState({ urlsend: url + this.DeliNumber.current.value })
            setTimeout(() => {
                this.switchshowform();
            }, 100);
        }
    }
    switchshowform = async (e) => {
        this.setState({ showform: !this.state.showform });
    }
    _SelectSetData = (type, data) => {


        switch (type) {
            case "withdrawaldate":
                this.setState({ documentDate: data })
                //  this.state.documentDate = data; 
                break;
            case "paymentdate": this.setState({ Docdate_Pay: data })
                break;
            default: break;
        }
    }
    Chackdoc = () => {
        Chackdocno(this.Groupdata_code.current.value, "CSOTHEREXPENSE").then(async (result1) => {
            if (result1 !== undefined) {
                this.DeliNumber.current.value = await result1
            } else {
                this.DeliNumber.current.value = ""
            }
        }).catch((err) => {
            this.DeliNumber.current.value = ""
            console.log(err);
        });
    }
    onClick = (e) => {
        if (e.target.value !== "") {
            switch (e.target.name) {
                case "Groupdata":
                    this.Groupdata.current.value = this.Groupdata_code.current.value
                    break;
                case "Department":
                    this.Department.current.value = this.Department_code.current.value
                    break;
                case "Branch":
                    this.Branch.current.value = this.Branch_code.current.value
                    break;
                default:
                    break;
            }
        }
    }
    onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (e.target.name === "Groupdata") {
                this.onAddValue("Groupdata", e.target.value);
                this.CustomerCode.current.focus()
            }
            if (e.target.name === "CustomerCode") {
                this.onAddValue("CustomerCode", e.target.value);
                this.Department.current.focus()
            }
            if (e.target.name === "Department") {
                this.onAddValue("Department", e.target.value);
                this.Branch.current.focus()
            }
            if (e.target.name === "Branch") {
                this.onAddValue("Branch", e.target.value);
            }
        }
    };
    onChange = (e) => {
        switch (e.target.name) {
            case 'Groupdata':
                if (e.target.value === "") {
                    this.setState({ Groupdata_txt: "" })
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                }
                break;
            case 'CustomerCode':
                if (e.target.value === "") {
                    this.CustomerCode.current.value = "";
                    this.CustomerName.current.value = "";
                }
                break;
            case 'Department':
                if (e.target.value === "") {
                    this.setState({ Department_txt: "" })
                    this.state.Department_txt = ""
                }
                break;
            case 'Branch':
                if (e.target.value === "") {
                    this.setState({ Branch_txt: "" })
                    this.Branch_code.current.value = ""
                }
                break;
            default:
                break;
        }
    }
    onBlur = (e) => {
        if (e.target.name === "Groupdata") {
            this.Groupdata.current.value = this.state.Groupdata_txt;
        }
        if (e.target.name === "Wtaxamount") {
            this.Wtaxamount.current.value = parseFloat(e.target.value).toFixed(2)
        }
        if (e.target.name === "Department") {
            this.Department.current.value = this.state.Department_txt;
        }
        if (e.target.name === "Branch") {
            this.Branch.current.value = this.state.Branch_txt;
        }
        if (e.target.name === "SaleDate") {
            if (e.target.value !== "") {
                this.state.documentDate = cheackdate(this.state.documentDate)
                setTimeout(() => {
                    if (cheackdate(this.state.documentDate) === "") {
                        this.SaleDate.current.focus()
                        this.setState({ opensnackbar: true })
                        this.setState({ color: "warning" })
                        this.setState({ icon: ErrorIcon })
                        this.setState({ messagealert: "รูปแบบวันที่ไม่ถูกต้อง" })
                    }
                }, 500);
            }
        }
        // console.log(this.Arcode2.current.value ,this.Arcode2.current.value === "" ? "" : this.state.Docdate_Pay);
    };
    CloseDialog = (e) => {
        this.setState({ openFullScreenDialog: e })
    }
    ReturnData = (e) => {
        console.log("eeeee", e);
        var selectpopup = this.state.selectpopup
        if (selectpopup === "Inputtax") {
            this.setState({ openFullScreenDialogs: e[0] })
            if (e !== "") {
                this.setState({ inputtax: e[1] })
                this.setState({ Refundablerate: e[2] })
                this.setState({ Refundablevalue: e[3] })
                this.setState({ Taxrefund: e[4] })
                this.setState({ Totaltax: e[5] })
            } else {
                this.setState({ inputtax: this.state.inputtax })
                this.setState({ Refundablerate: this.state.Refundablerate })
                this.setState({ Refundablevalue: this.state.Refundablevalue })
                this.setState({ Taxrefund: this.state.Taxrefund })
                this.setState({ Totaltax: this.state.Totaltax })
            }
        }
        if (selectpopup === "TaxWithholding") {
            this.setState({ openFullScreenDialogs: e[0] })
            if (e[1]) {
                console.log("sssssssssssssssssss", e[1])
                this.setState({ tableother: e[1] })
            }
            if (e[2]) {
                this.setState({ Deliverydate: e[2] })
            }
            if (e[3]) {
                this.setState({ Docgroupcode: e[3] })
            }
            if (e[4]) {
                this.setState({ Notax: e[4] })
            } else if (e[4] === "") {
                this.setState({ Notax: "" })
            }
            if (e[5]) {
                this.CustomerCode.current.value = e[5]
            }
            if (e[6]) {
                this.CustomerName.current.value = e[6]
            }
            if (e[7]) {
                this.setState({ taxtypecode: e[7] })
            } else if (e[7] === "") {
                this.setState({ taxtypecode: "" })
                this.setState({ taxtype: "" })
            }
            if (e[8]) {
                this.setState({ taxtype: e[8] })
            }
            if (e[9]) {
                this.setState({ Incometypecode: e[9] })
            }
            if (e[10]) {
                this.setState({ Incometype: e[10] })
            } else if (e[10] === "") {
                this.setState({ Incometypecode: "" })
                this.setState({ Incometype: "" })
            }
            if (e[11]) {
                this.setState({ Remark: e[11] })
            } else if (e[11] === "") {
                this.setState({ Remark: "" })
            }
            if (e[12]) {
                this.setState({ Deductionconditions: e[12] })
            }
            if (e[13]) {
                this.setState({ Taxrate: e[13] })
            }
            if (e[14]) {
                this.setState({ Amountbeforetax: e[14] })
            }
            if (e[15]) {
                this.setState({ Withholdingtax: e[15] })
            }
            if (e[16]) {
                this.setState({ Actingonbehalf: e[16] })
            }
            if (e[17]) {
                this.setState({ Totaltax: e[17] })
            }
        }
    }
    openDialog = (e) => {
        this.setState({ selectpopup: e })
        // let arrforparm = []
        if (e === "Inputtax") {
            let checkproducttb = ""
            if (this.state.products.length > 0) {
                for (let index = 0; index < this.state.products.length; index++) {
                    if (typeof (this.state.products[index].T_Code) !== "undefined") {
                        console.log("sssss", this.state.products[index].T_Code);
                        checkproducttb = this.state.products[index].T_Code
                    }

                }
            }
            if (checkproducttb === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกรายการในตารางก่อน ...!" })
                return
            }

            if (this.state.documentDate === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกวันที่ก่อน ...!" })
                return
            } /* else {
                arrforparm.push(this.state.documentDate)
            } */

            if (this.CustomerCode.current.value === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
                return
            }/*  else {
                arrforparm.push(this.CustomerCode.current.value)
            } */
            if (this.CustomerName.current.value === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
                return
            }/*  else {
                arrforparm.push(this.CustomerName.current.value)
            } */

            // arrforparm.push(this.TaxPersen.current.value)

            // // ข้อมูลในตาราง
            // arrforparm.push(this.state.inputtax)
            // //  อัตราขอคืนได้
            // arrforparm.push(this.state.Refundablerate)
            // // มูลค่าที่ขอคืนได้
            // arrforparm.push(this.state.Refundablevalue)
            // // ภาษีที่ขอคืนได้
            // arrforparm.push(this.state.Taxrefund)
            // // รวมยอดภาษี
            // arrforparm.push(this.state.Totaltax)

            // setTimeout(() => {
            //     this.setState({ parm: arrforparm })
            //     this.setState({ openFullScreenDialog: true })
            //     this.setState({ titleFullScreenDialog: "เลือกใบกำกับภาษีหลายใบ" })
            //     this.setState({ typeFullScreenDialog: e })
            // }, 100);

            let arrforparm = []
            arrforparm.push(this.state.documentDate)
            arrforparm.push(this.CustomerCode.current.value)
            arrforparm.push(this.CustomerName.current.value)
            arrforparm.push(7)
            // ข้อมูลในตาราง
            arrforparm.push(this.state.inputtax)
            //  อัตราขอคืนได้
            arrforparm.push(this.state.Refundablerate)
            // มูลค่าที่ขอคืนได้
            arrforparm.push(this.state.Refundablevalue)
            // ภาษีที่ขอคืนได้
            arrforparm.push(this.state.Taxrefund)
            // รวมยอดภาษี
            arrforparm.push(this.state.Totaltax)

            this.setState({ openFullScreenDialogs: true })
            this.setState({ typeFullScreenDialogs: e })
            this.setState({ titleFullScreenDialogs: "บันทึกภาษีซื้อ" })
            this.setState({ dataforpopup: arrforparm })
        }
        if (e === "TaxWithholding") {
            if (this.state.documentDate === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกวันที่ก่อน ...!" })
                return
            }
            if (this.CustomerCode.current.value === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
                return
            }
            if (this.CustomerName.current.value === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
                return
            }
            let table = this.state.products
            var btnw = false
            for (let i = 0; i < table.length && table[i].T_Code; i++) {
                if (table[i].BTN_W === "1") {
                    btnw = true
                }
                if (this.state.Amountbeforetax === "") {
                    this.setState({ Amountbeforetax: table[i].T_Amount })
                }
            }
            // if (btnw === false) {
            //     this.setState({ opensnackbar: true })
            //     this.setState({ color: "warning" })
            //     this.setState({ icon: ErrorIcon })
            //     this.setState({ messagealert: "กรุณากรอกข้อมูลในตารางและเลือก W ก่อน ...!" })
            //     return
            // }
            setTimeout(() => {
                let Data = []
                Data = {
                    from: "CSOTHEREXPENSE",
                    defulttable: this.state.tableother,
                    Deliverydate: this.state.Deliverydate,
                    Notax: this.state.Notax,
                    Payablecode: this.CustomerCode.current.value,
                    Payablename: this.CustomerName.current.value,
                    taxtypecode: this.state.taxtypecode,
                    taxtype: this.state.taxtype,
                    Incometypecode: this.state.Incometypecode,
                    Incometype: this.state.Incometype,
                    Remark: this.state.Remark,
                    Deductionconditions: this.state.Deductionconditions,
                    Taxrate: this.state.Taxrate,
                    Amountbeforetax: this.state.Amountbeforetax,
                    Withholdingtax: this.state.Withholdingtax,
                    Actingonbehalf: this.state.Actingonbehalf,
                    Totaltax: this.state.Totaltax,
                }
                this.setState({ parm: Data })
                this.setState({ openFullScreenDialogs: true })
                this.setState({ titleFullScreenDialogs: "บันทึกภาษีหัก ณ ที่จ่าย" })
                this.setState({ typeFullScreenDialogs: e })
            }, 200);
        }

        if (e === "Payrecord") {
            //this.setState({ parm: Data })
            this.setState({ openFullScreenDialogs: true })
            this.setState({ titleFullScreenDialogs: "บันทึกจ่ายเงิน" })
            this.setState({ typeFullScreenDialogs: e })
        }
    }
    componentWillUnmount() {
        localStorage.removeItem('inputtax');
    }
    SELECTPROJECT = (cell, row, enumObject, rowIndex) => {
        var btnShow = "";
        if (row.T_Code) {
            btnShow = (
                <div>
                    <SelectDatas
                        origin="PROJECT"  // ประเภท
                        valueSelect={e => this.SelectSetData("PROJECT", e, String(rowIndex))} // รับค่ากลับ
                        title="-"
                        defaultselect={row.PROJECT}// ค่าเริ่มต้นของ ประเภทราคา
                        opentitle={true}
                    />
                </div >
            )
        }
        return <div>{btnShow}</div>;
    };

    loadCarnumber = async () => {
        // https://psaccmdapi.pspl.co.th/CSCARNUMBER/Getcarnumber?api_key=JmeD3lEvTKVOp0pKPJwHsbGKGDAdZlo5cwbrhsYc&jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NDg4MTI4NzgsIlVzZXIiOnsiQ09ERSI6IjUxMjUyIiwiU0lURUNPREUiOiI3MDI4IiwiVVNFUkdST1VQIjoiMDEifX0.0bqZCwXSRebJxsP7lnCknP2dPcAjgYsNI3QFuWXBmTQ
        let url = 'CSCARNUMBER/Getcarnumber?'
        console.log("CSCARNUMBER", genURL(url));
        let res = await axios.get(genURL(url), { timeout: 12000 })
        //  label: 'The Lord of the Rings: The Two Towers'
        console.log("CSCARNUMBER", res);
        var elementcarnumber = [];
        if (res.data.length > 0) {
            for (let index = 0; index < res.data.length; index++) {
                elementcarnumber.push({ CODE: res.data[index].CODE, MYNAMETH: res.data[index].MYNAMETH })
            }
        }
        //   this.setState({ "carnumber": res.data })
        await this.setState({
            "carnumber": elementcarnumber
        })
    }


    setValue = (e, type) => {
        //  console.log("setValue", e);
        switch (type) {
            case "carnumber":
                //console.log("codeCarnumber", e[0]["CODE"]);
                this.setState({ "codeCarnumber": e[0]["CODE"] })
                break;

            default:
                break;
        }
    }
    // Report print 
    _printReport = (docno) => {
        try {
            if (formPrintdata.length > 1) {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length })
                return;
            }
        } catch (error) {

        }
        if (this.state.reporturl !== "") {
            this.setState({
                openReportFullScreenDialog: true,
                titleReportFullScreenDialog: "พิมพ์ใบบันทึกค่าใช้จ่ายอื่นๆ",
                urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docno}`
            })
        } else {
            this.ReplacePage(window.location.pathname + location.search)
        }
    }

    ReplacePage = (e) => {
        this.setState({ openBackdrop: false })
        window.location.replace(e);
    };

    CloseReportDialog = (e) => {
        this.setState({ openReportFullScreenDialog: e })
        this.ReplacePage(window.location.pathname + location.search)
    }
    //end report print


    reCheckGetData = async (type, val, fix) => {
        switch (type) {
            case "Groupdata":
                CheckCodeDocGroup(val, "CSOTHEREXPENSE").then((result) => {
                    console.log("result Groupdata", result);
                    this.Groupdata_code.current.value = val
                    this.Groupdata.current.value = result
                    this.setState({ Groupdata_txt: result });
                    this.setState({ Groupcode: val })
                    this.setState({ Groupname: result })
                }).finally(_ => {
                    // CheckTaxrate(val, "CSARDEPOSIT").then(async (result) => {
                    //   this.TaxPersen.current.value = await result
                    //  this.Taxrate.current.value = result
                    // })
                })
                break;
        }
    }


    render() {
        const listmenu = [
            ["บันทึกใบกำกับภาษีหลายใบ", "Inputtax"],
            ["บันทึกภาษีหัก ณ ที่จ่าย", "TaxWithholding"],
            ["บันทึกจ่ายเงิน", "Payrecord"]
        ]
        const onClick = (e) => {

            switch (e) {
                case "save":
                    this._saveConnection()
                    break;
                case "new":
                    this.ReplacePage(window.location.pathname + location.search)
                    break;
                case "print":
                    this._print.bind(null)
                    break;
                case "search":
                    this.setState({ openFullScreenDialogs: true })
                    this.setState({ typeFullScreenDialogs: e })
                    this.setState({ titleFullScreenDialogs: "ค้นหาบันทึกค่าใช้จ่ายอื่นๆ" })
                    break;
                case "Inputtax":
                    this.openDialog(e)
                    break;
                case "TaxWithholding":
                    // this.SetPopUpcsvarinvbalpay()
                    this.openDialog(e)
                    break;
                case "Payrecord":
                    this._saveConnection()
                    // this.openDialog(e)
                    break;
                default:
                    break;
            }
        }
        const type = this.state.typeFullScreenDialogs
        const CloseDialogs = () => {
            this.setState({ openFullScreenDialogs: false })
        }
        return (
            <div className="PSApp" onClick={this.onClick} onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur}>

                <FullScreenDialognew open={this.state.openReportFullScreenDialog} title={this.state.titleReportFullScreenDialog} CloseDialog={e => this.CloseReportDialog(e)}>
                    <Repostview url={this.state.urlsend} />
                </FullScreenDialognew>

                <Backdrop open={this.state.openBackdrop} />
                <FullScreenDialogs open={this.state.openFullScreenDialogs} title={this.state.titleFullScreenDialogs} closeDialog={e => CloseDialogs(e)}>
                    {type === "Inputtax" ?
                        < Inputtax parm={this.state.dataforpopup} resdata={e => this.ReturnData(e)}
                            recheckeddata={this.state.resrecheckeddata}
                            from="CSOTHEREXPENSE"
                        />
                        : null}
                    {type === "TaxWithholding" ? <Withholding parm={this.state.parm}
                        resdata={e => this.ReturnData(e)}
                        from="CSOTHEREXPENSE"
                        recheckeddata={this.state.resrecheckeddata}
                    /> : null}
                    {type === "Search_Expense" ?
                        <PopUpCSEXPENSE closePopup={e => CloseDialogs(e)} Get_PopUpCSEXPENSE={this.Get_PopUpCSEXPENSE} /> : null}
                    {type === "Payrecord" ? <PopUpSaveMoneyExp closePopup={this.Switch_PopUpSaveMoney}
                        AmountPayable={!this.state.AmountPayable ? "0" : this.state.AmountPayable}
                        Wtaxamount={this.Wtaxamount.current.value}
                        date={this.state.documentDate}
                        from="CSOTHEREXPENSE"
                        get_PopUpSaveMoney={this._get_PopUpSaveMoney}
                        pms="R|1|1|1|1|1|1"
                        recheckeddata={this.state.resrecheckeddata} /> : null}
                    {type === "search" ?
                        <Rechecked Dataselect={e => this._reCHK(e)} from="CSOTHEREXPENSE" />
                        : null}
                </FullScreenDialogs>
                {this.state.showPopupOT ? <PopUpOther2 closePopup={this.PopUpOtherClose} type={this.state.PopUpTYpe} Get_PopUpOther={this.Get_PopUpOther2}/* Data={this.state.valuePopup} */ userSite={this.state.siteCodeUser} from="CSOTHEREXPENSE" /> : null}
                {this.state.SwitchPopupApcode ? <PopupApcode closePopup={this.Switch_PopupApcode} Get_PopupApcode={this.Get_PopupApcode} /> : null}
                {this.state.SwitchOtherPopup ? <PopUpOther closePopup={this.Switch_OtherPopup} type={this.state.OtPopupType} Get_PopUpOther={this.Get_PopUpOther} userSite={this.state.siteCodeUser} from="CSOTHEREXPENSE" /> : null}
                {/* พิมพ์ฟอร์ม */}
                <div className="displaymain">
                    <Topbar
                        listmenu={listmenu}
                        onClick={e => onClick(e)}
                        title="บันทึกค่าใช้จ่ายอื่นๆ"
                    />
                    <div className="PSAppfrom">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12} xl={4} lg={4} >
                                <MaterialUIPickers title="วันที่เอกสาร"
                                    DateValue={e => this._SelectSetData("withdrawaldate", e)}
                                    defaultdate={this.state.defaultdocumentDate}
                                    open={this.state.checkenableInput['DOCDATE']}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'">
                                        <span className="input-group-addon" > กลุ่มข้อมูล  </span>
                                        <input type="text" className="form-control hidden" ref={this.Groupdata_code} />
                                        <input type="text" className="form-control" name="Groupdata" ref={this.Groupdata} />
                                        <span id="iconGroupdata" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}><i > <ArrowDropDownRoundedIcon fontSize="small" /></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={12} xl={4} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'">
                                        <span className="input-group-addon">เลขที่เอกสาร  </span>
                                        <input type="text" className="form-control" ref={this.DeliNumber} /* readOnly */ />
                                        <span id="iconTaxNumber" className="input-group-addon icon">
                                            <i className="fas fa-sync-alt" onClick={() => this.Chackdoc()}></i>
                                        </span>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <Hidden mdUp>
                            <br></br>
                        </Hidden>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12} xl={4} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'">
                                        <span className="input-group-addon">รหัสเจ้าหนี้  </span>
                                        <input type="text" className="form-control" name="CustomerCode" ref={this.CustomerCode}
                                        />
                                        <span onClick={this.Switch_PopupApcode.bind(null)} id="iconCustomerCode" className="input-group-addon icon">
                                            <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                        </span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={12} xl={4} lg={4}>
                                <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'">
                                        <span id="iconCustomerName" className="input-group-addon icon"><i className="fas fa-user"></i></span>
                                        <input type="text" className="form-control" disabled ref={this.CustomerName} />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <div className="PSAppTable">
                        <div className="form-group col-md-12">
                            <div className="form-row">
                                <BootstrapTable
                                    data={this.state.products}
                                    trClassName='trClassName'
                                    tableHeaderClass='trClassName'
                                    options={{
                                        noDataText: "...",
                                        onRowClick: this.onRowClick,
                                    }}
                                    cellEdit={{ //แก้ไข
                                        mode: 'click',
                                        blurToSave: true,
                                        beforeSaveCell: this.onBeforeSaveCell,
                                        afterSaveCell: this.onAfterSaveCell,
                                    }}
                                    height='400'
                                >
                                    <TableHeaderColumn row="0" rowSpan="2" dataField='C0' isKey width="35" dataAlign="center"></TableHeaderColumn>
                                    <TableHeaderColumn row="0" colSpan="2" dataAlign="left" width="100" className="colbuttomhidden" > <div align="center" className="custom-header-class"> รหัส </div> </TableHeaderColumn>
                                    <TableHeaderColumn row="1" dataField='T_Code' editable={this.state.col1} dataAlign="left" width="70" ></TableHeaderColumn>
                                    <TableHeaderColumn row="1" dataField='BTN_Code' editable={false} dataAlign="center" width="30" dataFormat={this._cellButton.bind(this)} columnClassName='columnClassNameFormat1'><i id="TableLoadItem" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                                    <TableHeaderColumn row="0" rowSpan="2" dataField='T_List' editable={false} dataAlign="left" width="150" columnTitle> <div align="center"> รายการ </div> </TableHeaderColumn>
                                    <TableHeaderColumn row="0" rowSpan="2" dataField='T_Explain' editable={this.state.col} dataAlign="left" width="150" columnTitle><div align="center">อธิบายเพิ่มเติม</div>  </TableHeaderColumn>
                                    <TableHeaderColumn row="0" rowSpan="2" dataField='T_Amount' editable={this.state.col} dataAlign="right" width="80" columnTitle><div align="center">จำนวนเงิน</div></TableHeaderColumn>
                                    <TableHeaderColumn row="0" colSpan="2" editable={true} dataAlign="center" width="110" className="colbuttomhidden"  > แผนก </TableHeaderColumn>
                                    <TableHeaderColumn row="1" dataField='T_Department' editable={this.state.col} dataAlign="left" width="80" columnTitle ></TableHeaderColumn>
                                    <TableHeaderColumn row="1" dataField='BTN_Department' editable={false} dataAlign="center" width="30" dataFormat={this._cellButton2.bind(this)} columnClassName='columnClassNameFormat1'><i id="TableLoadItem" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                                    <TableHeaderColumn row="0" dataField='T_Department_Code' editable={false} dataAlign="center" hidden></TableHeaderColumn>
                                    <TableHeaderColumn row="0" dataField='T_Department_Name' editable={false} dataAlign="center" hidden></TableHeaderColumn>
                                    <TableHeaderColumn row="0" rowSpan="2" dataField="PROJECT" editable={false} dataAlign="center" dataFormat={this.SELECTPROJECT.bind(this)} width="150"><div align="center"> โครงการ </div></TableHeaderColumn>
                                    <TableHeaderColumn row="0" colSpan="2" editable={true} dataAlign="center" width="800" className="colbuttomhidden" > สาขา </TableHeaderColumn>
                                    <TableHeaderColumn row="1" dataField='T_Branch' editable={this.state.col} dataAlign="left" width="90" > </TableHeaderColumn>
                                    <TableHeaderColumn row="1" dataField='BTN_Branch' editable={false} dataAlign="center" width="30" dataFormat={this._cellButton3.bind(this)} columnClassName='columnClassNameFormat1'>    <i id="TableLoadItem" style={{ fontSize: "10px" }}></i></TableHeaderColumn>
                                    <TableHeaderColumn row="1" dataField='T_Branch_Code' editable={false} dataAlign="center" hidden >T_Branch_Code</TableHeaderColumn>
                                    <TableHeaderColumn row="1" dataField='T_Branch_Name' editable={false} dataAlign="center" hidden >T_Branch_Name</TableHeaderColumn>
                                    <TableHeaderColumn row="0" dataField='BTN_T' editable={false} dataAlign="center" width="35" rowSpan="2" dataFormat={this.Button_T.bind(this)}> T </TableHeaderColumn>
                                    <TableHeaderColumn row="0" dataField='BTN_W' editable={false} dataAlign="center" width="35" rowSpan="2" dataFormat={this.Button_W.bind(this)}> W </TableHeaderColumn>
                                    <TableHeaderColumn row="0" dataField='T_Wtaxamount' dataAlign="center" hidden >T_Wtaxamount</TableHeaderColumn>
                                    <TableHeaderColumn row="0" dataField='T_Wtaxrate' dataAlign="center" hidden>T_Wtaxrate</TableHeaderColumn>
                                    <TableHeaderColumn row="0" rowSpan="2" dataField="projectcode" editable={false} dataAlign="center" width="150"
                                        hidden
                                    >projectcode</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>
                    </div>
                    <div className="PSAppfrom">
                        <Grid>
                            <Col xs={12} sm={8} md={8} lg={8}>
                                <Row className="show-grid">
                                    <Col xs={12} sm={6} md={6} lg={6}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">พนักงาน  </span>
                                                    <input type="text" className="form-control hidden" ref={this.Csuser_code} />
                                                    <input type="text" className="form-control" ref={this.Csuser} disabled />
                                                    <span id="iconTaxNumber" className="input-group-addon icon">
                                                        <i className="fas fa-sync-alt" onClick={() => this.onAddValue("Csuser", this.state.siteCodeUser1)}></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon"> แผนก  </span>
                                                    <input type="text" className="form-control hidden" ref={this.Department_code} readOnly />
                                                    <input type="text" className="form-control" name="Department" ref={this.Department}
                                                    />
                                                    <span id="iconDepartment" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Department")}><i > <ArrowDropDownRoundedIcon fontSize="small" /></i></span>
                                                </div>
                                            </div>
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <SelectDatas
                                                        origin="PROJECT"  // โครงการ
                                                        valueSelect={e => this.SelectSetData("PROJECT", e, "")} // รับค่ากลับ
                                                        title="โครงการ"
                                                        defaultselect={this.state.PROJECT}// ค่าเริ่มต้นของ โครงการ
                                                    />
                                                </div>
                                            </div>

                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={6} md={6} lg={6}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">สาขา  </span>
                                                    <input type="text" className="form-control hidden" ref={this.Branch_code} readOnly />
                                                    <input type="text" className="form-control" name="Branch" ref={this.Branch}
                                                    />
                                                    <span id="iconBranch" className="input-group-addon icon" onClick={this.Switch_OtherPopup.bind(null, "Branch")}><i > <ArrowDropDownRoundedIcon fontSize="small" /></i></span>
                                                </div>
                                            </div>
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <SelectDatas
                                                        origin="PriceType"  // ประเภท
                                                        valueSelect={e => this.SelectSetData("PriceType", e)} // รับค่ากลับ
                                                        title="ประเภทราคา"
                                                        defaultselect={this.state.PriceTypedefaultselect}// ค่าเริ่มต้นของ ประเภทราคา
                                                    />
                                                </div>
                                            </div>
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">หัก ณ ที่จ่าย  </span>
                                                    <input type="text" className="form-control Price" ref={this.Wtaxamount} name="Wtaxamount"
                                                        onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); e.target.select() }} />
                                                </div>
                                            </div>

                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">หมายเหตุ  </span>
                                                    <input type="text" className="form-control" ref={this.Remark} />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={6} md={6} lg={6}>
                                        <Row className="show-grid">

                                        </Row>
                                    </Col>
                                    <Col xs={12} sm={6} md={6} lg={6}>
                                        <Row className="show-grid">

                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4}>
                                <Row className="show-grid">
                                    <Col xs={12} sm={12} md={12} lg={12}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">รวมจำนวนเงิน  </span>
                                                    <input type="text" className="form-control Price" ref={this.SumPrice} readOnly />
                                                </div>
                                            </div>
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">ภาษีมูลค่าเพิ่ม  </span>
                                                    <input type="text" className="form-control Price" ref={this.TaxPersen}
                                                        onClick={(e) => { e.target.value = parseFloat(e.target.value).toFixed(0); }}
                                                        // onKeyDown={this.Cal_Price1}
                                                        onBlur={this.Cal_Price.bind(this)} />
                                                    <span className="input-group-addon icon"><i className="fas fa-percentage"></i></span>
                                                    <input type="text" className="form-control Price" ref={this.TaxPrice} readOnly />
                                                </div>
                                            </div>
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon ">มูลค่ารวมภาษี  </span>
                                                    <input type="text" className="form-control Price" ref={this.valueTax} readOnly />
                                                </div>
                                            </div>
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon"> มูลค่ายกเว้น  </span>
                                                    <input type="text" className="form-control Price" ref={this.ValueExcept} readOnly />
                                                </div>
                                            </div>
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon"> รวมเงินทั้งสิ้น  </span>
                                                    <input type="text" className="form-control Price" ref={this.TotalPrice} readOnly />
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Panel>
                                        <Panel.Heading>
                                            <Panel.Title componentClass="h5">ข้อมูลเพิ่มเติม ( User's Field) </Panel.Title>
                                        </Panel.Heading>
                                        <Panel.Body>
                                            <Col xs={12} sm={12} md={12} lg={12} >
                                                <Row className="show-grid">
                                                    <Col xs={12} sm={12} md={12} lg={4}>
                                                        <div className="row">
                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                    <span className="input-group-addon "> รหัสลูกค้า  </span>
                                                                    <input type="text" className="form-control " ref={this.Arcode2} tabIndex={6} />
                                                                </div>
                                                            </div>
                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                    <span className="input-group-addon "> เลขที่บิลขาย  </span>
                                                                    <input type="text" className="form-control " ref={this.SaleDocno} tabIndex={7} />
                                                                </div>
                                                            </div>
                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12</div> col-sm-12 col-md-12 col-lg-12">
                                                                    <UseAutocomplete title="ทะเบียนรถ" id="carnumber"
                                                                        datalist={this.state.carnumber}
                                                                        valueReturn={e => this.setValue(e, "carnumber")}
                                                                        activate={_ => this.loadCarnumber()}
                                                                        placeholder={this.state.cbcdefaultvalue}
                                                                    />

                                                                    {/* <ComboBoxautocomplete label="ทะเบียนรถ"
                                                                        data={this.state.carnumber}
                                                                        rsvalue={e => this.setValue(e)}
                                                                        defaultvalue={this.state.cbcdefaultvalue}
                                                                    /> */}

                                                                    {/* <span className="input-group-addon "> ทะเบียนรถ  </span> */}
                                                                    {/* <input type="text" className="form-control" ref={this.Carnumber} tabIndex={8} /> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={4}>
                                                        <div className="row">
                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                    <span className="input-group-addon "> ระยะทาง  </span>
                                                                    <input type="text" className="form-control Price" ref={this.Kilometer} tabIndex={9} />
                                                                </div>
                                                            </div>
                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                    <span className="input-group-addon "> เลขไมล์ก่อน  </span>
                                                                    <input type="text" className="form-control Price" ref={this.Kilometer_2} tabIndex={10} />
                                                                </div>
                                                            </div>
                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                    <span className="input-group-addon "> เลขไมล์หลัง  </span>
                                                                    <input type="text" className="form-control Price" ref={this.Kilometer_3} tabIndex={11} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={4}>
                                                        <div className="row">

                                                            <MaterialUIPickers title="วันที่จ่ายเงิน"
                                                                DateValue={e => this._SelectSetData("paymentdate", e)}
                                                                defaultdate={this.state.defaultdocumentDate} />


                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                    <span className="input-group-addon "> จ่ายในนาม  </span>
                                                                    <input type="text" className="form-control " ref={this.Name_Pay} tabIndex={13} />
                                                                </div>
                                                            </div>
                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                    <span className="input-group-addon "> บัญชีปลายทาง  </span>
                                                                    <input type="text" className="form-control " ref={this.Account_Pay} tabIndex={14} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={4}>
                                                        <div className="row">
                                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                                    <span className="input-group-addon "> เบอร์โทร  </span>
                                                                    <input type="text" className="form-control " ref={this.Telephone_AR} tabIndex={15} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Panel.Body>
                                    </Panel>
                                </Col>
                            </Row>
                        </Grid>
                        <Snackbar place="br"
                            color={this.state.color}
                            icon={this.state.icon}
                            autoClose={this.state.autoClose}
                            message={this.state.messagealert}
                            open={this.state.opensnackbar}
                            closeNotification={() => { this.setState({ opensnackbar: false }) }}
                            close />
                    </div>
                </div>
            </div >
        )
    }
}
